import { render, staticRenderFns } from "./DeviceView.vue?vue&type=template&id=71a53654&scoped=true"
import script from "./DeviceView.vue?vue&type=script&lang=js"
export * from "./DeviceView.vue?vue&type=script&lang=js"
import style0 from "./DeviceView.vue?vue&type=style&index=0&id=71a53654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a53654",
  null
  
)

export default component.exports